import React, { createContext, useContext, useState, useEffect } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const u = localStorage.getItem("jastip_user");
    return u ? JSON.parse(u) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("jastip_token");
    if (token) {
      api.get("/auth/me").then((r) => {
        setUser(r.data);
        localStorage.setItem("jastip_user", JSON.stringify(r.data));
      }).catch(() => {}).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("jastip_token", r.data.token);
    localStorage.setItem("jastip_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("jastip_token");
    localStorage.removeItem("jastip_user");
    setUser(null);
    window.location.href = "/login";
  };

  const updateUser = (updated) => {
    setUser(updated);
    localStorage.setItem("jastip_user", JSON.stringify(updated));
  };

  const isAdmin = user && user.role === "admin";

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isAdmin, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
